export default "__VITE_ASSET__DtolK1cd__"